import { InsuranceType, MainPath } from "Constants/constants";

export const PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.ELECTRIC_SCOOTER}`;
